import { MyAreaStepperWidgetProps } from '@msc-b2c/interfaces/types';
import { getActiveSession, useGetBookingQuery, useGetCheckinsQuery } from '@msc-b2c/shared-utils';
import styles from './stepperwidget.module.scss';
import {
  getCabinIdOfTheLoggedUser,
  getCabinObjectOfTheLoggedUser,
  getDepartureDate,
} from '../utils/myAreaUtils';
import { BookingStatusEnum } from '@msc-b2c/interfaces/enums';
import { getCheckinStartDate, isStatusComplete } from '../utils/checkinUtils';
import { getSortedSteps, operateOnSteps } from './utils/stepperWidgetUtils';
import { Icon, Text } from '@msc-b2c/shared-components';
import { skipToken } from '@reduxjs/toolkit/query';

export function StepperWidget({ steps }: Readonly<MyAreaStepperWidgetProps>) {
  const { bookingNumber = '' } = getActiveSession();
  const { data: booking } = useGetBookingQuery(
    bookingNumber && bookingNumber !== '' ? bookingNumber : skipToken
  );
  const cabinId = getCabinIdOfTheLoggedUser(booking) ?? '';
  const { data: checkInStatus } = useGetCheckinsQuery(
    bookingNumber && cabinId ? { bookingNumber, cabinId } : skipToken
  );
  const loggedUserCabin = getCabinObjectOfTheLoggedUser(booking);

  if (booking?.status?.code === BookingStatusEnum.OPTIONAL) {
    document.querySelector('.-my-msc-overview-journey')?.classList?.add('courtesy-hold');
  }

  const isCabinAssigned = loggedUserCabin?.number !== 'G00000';
  const isBookingConfirmed = booking?.status?.code === BookingStatusEnum.BOOKED;
  const isBookingOptional = booking?.status?.code === BookingStatusEnum.OPTIONAL;
  const isCheckInDoneForAll = isStatusComplete(checkInStatus);

  const departureDate = getDepartureDate(booking);
  const checkinStart = getCheckinStartDate(departureDate);

  const stepContext = {
    isCheckInDoneForAll,
    isBookingConfirmed,
    isBookingOptional,
    isCabinAssigned,
    checkinStart,
    booking,
  };

  // new steps with status and labels with placeholders
  const newSteps = steps.map((step) => operateOnSteps(step, stepContext));

  // sort steps based on isDisabled property
  const sortedSteps = getSortedSteps(newSteps);

  return (
    <div className="stepper-widget">
      {sortedSteps.map((step, index) => (
        <div
          key={`step-${index}-${step.type}`}
          className={`${styles.step} ${step.type}`}
        >
          <div
            className={`stepper-indicator ${
              step.isDisabled ? styles.iconDisabled : styles.iconEnabled
            }`}
          >
            <Icon icon={step.icon} />
          </div>
          <Text
            text={step.isDisabled ? step.stepDisabledLabel : step.stepActiveLabel}
            styleOption={`body-default-normalize stepper-placeholder ${
              step.isDisabled ? 'disabled' : ''
            }`}
          />
        </div>
      ))}
    </div>
  );
}
